import React from 'react'
import USAMap from 'react-usa-map'

import Loading from '../components/loading'
import mapColors from '../util/map-colors'
import MapNationalKey from '../components/map-national-key'
import MapRegionalKey from '../components/map-regional-key'
import request from '../util/request'
import statesToArray from '../util/states-to-array'

const regions = require('../../../../static/data/region.json'); 

const sortByOverall = (a, b) =>
  parseFloat(b[1]['OVERALL']) - parseFloat(a[1]['OVERALL'])

const totalOverall = states =>
  states.reduce((value, current) => (value + current.overall), 0)

const averageOveral = states => totalOverall(states) / states.length

const regionByOverall = (region, dimensions) => statesToArray(dimensions)
  .filter(
    item => regions[region].includes(item.state),
  )
  .sort(sortByOverall)
  .map((item, index) => ({
    ...item,
    overall: parseFloat(item[1]['OVERALL']),
    regionIndex: index
  }))

const stateSectionNational = (state, dimensions) => {
  const values = statesToArray(dimensions)
    .sort(sortByOverall)
    .map((item, index) => ({
      ...item,
      overall: parseFloat(item[1]['OVERALL']),
      index
    }))
  const stateInList = values.filter(
    item => item.state === state,
  )[0]
  if (stateInList.index < 1) {
    return 1
  }
  if (stateInList.overall >= averageOveral(values)) {
    return 2
  }
  return 3
}

const stateSectionRegional = (state, region, dimensions) => {
  const values = regionByOverall(region, dimensions)
  const stateInRegion = values.filter(
    item => item.state === state,
  )[0]
  if (stateInRegion.regionIndex < 1) {
    return 1
  }
  if (stateInRegion.overall >= averageOveral(values)) {
    return 2
  }
  return 3
}

class Map extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
      region: '',
    }
    this.onStateClick = this.onStateClick.bind(this)
  }

  componentWillMount() {
    const { data } = this.state
    /* istanbul ignore next */
    if (!data.dimensions) {
      this.loadJSON('dimensions')
    }
  }

  onStateClick(state) {
    const { region } = this.state
    const clickedRegions = Object.keys(regions).filter(
      clickRegion => regions[clickRegion].includes(state),
    )
    if (clickedRegions.length === 0 || clickedRegions[0] == region) {
      this.setState({ region: '' })
    } else {
      this.setState({ region: clickedRegions[0] })
    }
  }

  statesCustomConfig() {
    const { data, region } = this.state
    const { dimensions } = data
    return Object.keys(dimensions).reduce((config, state) => {
      let stateColor = '#D8D8D8'
      if (region === '') {
        stateColor = mapColors[stateSectionNational(state, dimensions)]
      } else if (regions[region].includes(state)) {
        stateColor = mapColors[
          stateSectionRegional(state, region, dimensions)
        ]
      }
      if (state === 'DC') {
        return {
          ...config,
          DC1: {
            fill: stateColor,
          },
          DC2: {
            fill: stateColor,
          },
        }
      }
      return {
        ...config,
        [state]: {
          fill: stateColor,
        },
      }
    }, {})
  }

  async loadJSON(name) {
    const newData = await request(`/data/${name}.json`)
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [name]: newData,
      },
    }))
  }

  render() {
    const { data } = this.state
    if (!data.dimensions) {
      return (<Loading message="Loading data..." />)
    }
    return (
      <div>
        <USAMap
          title=""
          customize={this.statesCustomConfig()}
          onClick={e => this.onStateClick(e.target.dataset.name)}
        />
        {this.state.region === '' ? <MapNationalKey /> : <MapRegionalKey />}
      </div>
    )
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Visualizations/containers/map.jsx